import { APIService } from '../../../lib/api/APIService';

// Website Reasoning API class extending the base APIService
class WebsiteReasoningAPI extends APIService {
  async getHealth() {
    return this.get('/api/website-reasoning-test/health');
  }

  async uploadFiles(formData) {
    // FormData needs to be sent directly, not as JSON
    const token = this.getAccessToken();
    const url = `${this.baseURL}/api/website-reasoning-test/upload`;
    
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Authorization': token ? `Bearer ${token}` : '',
      },
      credentials: 'include',
      body: formData
    });

    if (!response.ok) {
      const error = await response.json().catch(() => ({ error: 'Failed to upload files' }));
      throw new Error(error.error || `HTTP error! status: ${response.status}`);
    }

    return response.json();
  }

  async generateQuiz(cacheKey, numQuestions = 5, topicFocus = 'general') {
    return this.post('/api/website-reasoning-test/generate_quiz', {
      cache_key: cacheKey,
      num_questions: numQuestions,
      topic_focus: topicFocus
    });
  }

  async flagQuestion(questionId, reason, questionData) {
    return this.post('/api/website-reasoning-test/flag_question', {
      question_id: questionId,
      reason: reason,
      question_data: questionData
    });
  }

  async startQuiz(type, timeLimit = 300, additionalData = {}) {
    return this.post('/api/website-reasoning-test/start_quiz', {
      type: type,
      time_limit: timeLimit,
      ...additionalData
    });
  }

  async getQuestion(quizId) {
    if (!quizId) {
      throw new Error('No active quiz');
    }
    return this.get(`/api/website-reasoning-test/get_question?quiz_id=${encodeURIComponent(quizId)}`);
  }

  async submitAnswer(answer, quizId) {
    return this.post('/api/website-reasoning-test/submit_answer', {
      answer: answer,
      quiz_id: quizId,
    });
  }

  async endQuiz(quizId) {
    return this.post('/api/website-reasoning-test/end_quiz', {
      quiz_id: quizId,
    });
  }
}

// Create and export website reasoning API instance
export const websiteReasoningAPI = new WebsiteReasoningAPI();
